import React, { useRef } from 'react';
import { encode } from 'querystring';
import { useRouter } from '../../../hooks/useCustomRouter';
import { FEATURE } from '../../../constants/emarsys/feature';
import eventClickNCL from '../../../helpers/emarsys/new-car-list/eventClickNCL';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { BUTTON_NAME_NEW_CAR_LIST } from '../../../constants/emarsys/new-car-list';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import eventClickCouponServiceList from '../../../helpers/emarsys/coupon-service/eventClickCouponServiceList';
import {
  BUTTON_NAME_SERVICE_COUPON,
  SECTION_NAME_SERVICE_COUPON,
} from '../../../constants/emarsys/service-coupon';
import eventClickPackageServiceList from '../../../helpers/emarsys/package-service/eventClickPackageServiceList';
import {
  BUTTON_NAME_SERVICE_PACKAGE,
  SECTION_NAME_SERVICE_PACKAGE,
} from '../../../constants/emarsys/service-package';
import useImpressionTestDriveList from '../../../hooks/emarsys/test-drive/useImpressionTestDriveList';
import {
  BUTTON_NAME_TEST_DRIVE_LIST,
  SECTION_NAME_TEST_DRIVE_LIST,
} from '../../../constants/emarsys/test-drive';
import eventClickTestDriveList from '../../../helpers/emarsys/test-drive/eventClickTestDriveList';

export interface IsortModal {
  value?: string;
  name: string;
  selected: boolean;
  code: string;
}

export interface SortModalContentProps {
  sortsList: IsortModal[];
  setTriggerGTM?: (value: boolean) => void;
  setViewSortModal?: (value: boolean) => void;
  impressionData?: {
    customerNo?: string;
    title?: string;
    carCategory?: string;
    carModel?: string;
    carModels?: string[];
    sectionName?: string;
    breadcrumbItems?: IBreadcrumbs[];
    filterValue?: {
      price?: string;
      search?: string;
      color?: string;
      fuel_type?: string;
      transmission?: string;
      capacity?: string;
      tag?: string;
      order_by?: string;
      special_offer?: string;
      car_model?: string;
    };
    category?: string;
    menu_cat_lvl1?: string;
    menu_cat_lvl2?: string;
  };
  feature?: string;
  breadcrumbItems?: IBreadcrumbs[];
}

export default function SortModalContent({
  sortsList,
  setTriggerGTM,
  setViewSortModal,
  impressionData,
  feature,
  breadcrumbItems,
}: SortModalContentProps) {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);
  const router = useRouter();
  const impressionRef = useRef(null);

  const handleOptionChange = (e) => {
    const newValue = e.target.value;
    const existingQueryParams = router.query;
    if (existingQueryParams?.sort) {
      delete existingQueryParams.sort;
    }
    const newUrl = `${new URLSearchParams(
      existingQueryParams ? encode(existingQueryParams) : ''
    ).toString()}`;

    if (feature === FEATURE.LISTING_NEW_CAR) {
      eventClickNCL(
        dispatch,
        userData?.customerNo || '',
        impressionData?.title || '',
        impressionData?.carCategory || '',
        '',
        impressionData?.sectionName || '',
        BUTTON_NAME_NEW_CAR_LIST.SORT,
        breadcrumbItems,
        {
          ...impressionData.filterValue,
          order_by: sortsList?.find((item) => item.code === newValue)?.name,
        }
      );
    }
    if (feature === 'PACKAGE_SERVICE_LIST') {
      eventClickPackageServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        impressionData?.customerNo,
        SECTION_NAME_SERVICE_PACKAGE.FILTER,
        BUTTON_NAME_SERVICE_PACKAGE.URUTKAN,
        impressionData?.carModels,
        {
          ...impressionData.filterValue,
          order_by: sortsList?.find((item) => item.code === newValue)?.name,
        }
      );
    }

    if (feature === 'COUPON_SERVICE_LIST') {
      eventClickCouponServiceList(
        dispatch,
        impressionData.carCategory,
        impressionData?.title,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        SECTION_NAME_SERVICE_COUPON.FILTER,
        BUTTON_NAME_SERVICE_COUPON.URUTKAN,
        {
          ...impressionData.filterValue,
          order_by: sortsList?.find((item) => item.code === newValue)?.name,
        }
      );
    }
    if (feature === FEATURE.TEST_DRIVE_LISTING_PAGE) {
      eventClickTestDriveList(
        impressionData?.title,
        impressionData.category,
        SECTION_NAME_TEST_DRIVE_LIST.SORT,
        BUTTON_NAME_TEST_DRIVE_LIST.SORT,
        impressionData?.menu_cat_lvl1,
        {
          orderBy: sortsList?.find((e) => e.code === newValue)?.name,
          menu_cat_lvl2: impressionData?.menu_cat_lvl2,
        }
      );
    }

    if (newUrl === '') {
      router.push(`${router.pathname}?sort=${newValue}`);
    } else {
      router.push(`${router.pathname}?sort=${newValue}&` + newUrl);
    }
    setTimeout(() => {
      setViewSortModal(false);
    }, 1000);
  };

  if (feature === FEATURE.TEST_DRIVE_LISTING_PAGE) {
    useImpressionTestDriveList(
      impressionRef,
      impressionData?.title,
      SECTION_NAME_TEST_DRIVE_LIST.SORT,
      { category: impressionData.category, menu_cat_lvl2: impressionData?.menu_cat_lvl2 }
    );
  }

  return (
    <ul className="space-y-3 w-full text-sm text-gray-700 " ref={impressionRef}>
      {sortsList.map((option, index) => (
        <li key={index} className="border-b px-4">
          <div className="w-full flex wrapper-radio items-center py-2 ">
            <input
              id={`radio-${option.code}`}
              type="radio"
              value={option.code}
              name="radio-options"
              className="w-4 h-4 text-[#231F20] bg-gray-100  focus:ring-reliableBlack60"
              checked={option.selected}
              onChange={handleOptionChange}
              onClick={() => setTriggerGTM(true)}
            />
            <label
              htmlFor={`radio-${option.code}`}
              className="w-full text-start ml-2 text-sm font-medium text-[#231F20]"
            >
              {option.name}
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}
